import React from "react";

import { Link } from "react-router-dom";

import { FaArrowRight, FaBlog, FaCalendarAlt, FaUser } from "react-icons/fa";

import useBlogs from "../../hooks/useBlogs";

import { formatBlogDate } from "../../data/blogs";

import "./Blogs.css";

const Blogs = () => {
  const { blogs, loading, error } = useBlogs(true);

  // ============================================================
  // LOADING
  // ============================================================

  if (loading) {
    return (
      <main className="public-blogs-page">
        <div className="public-blogs-loading">
          <div className="public-blogs-spinner"></div>

          <p>Loading blogs...</p>
        </div>
      </main>
    );
  }

  // ============================================================
  // ERROR
  // ============================================================

  if (error) {
    return (
      <main className="public-blogs-page">
        <div className="public-blogs-empty">
          <FaBlog />

          <h2>Unable to load blogs</h2>

          <p>Please try again later.</p>
        </div>
      </main>
    );
  }

  // ============================================================
  // PAGE
  // ============================================================

  return (
    <main className="public-blogs-page">
      {/* HERO */}

      <section className="public-blogs-hero">
        <div className="public-blogs-hero-inner">
          <span>Quality Sports Surface</span>

          <h1>Our Blogs</h1>

          <p>
            Expert insights, guides and ideas about sports surfaces, courts and
            sports infrastructure.
          </p>
        </div>
      </section>

      {/* BLOGS */}

      <section className="public-blogs-section">
        <div className="public-blogs-container">
          {blogs.length === 0 ? (
            <div className="public-blogs-empty">
              <FaBlog />

              <h2>No blogs available</h2>

              <p>Check back soon for new articles.</p>
            </div>
          ) : (
            <div className="public-blogs-grid">
              {blogs.map((blog) => (
                <article className="public-blog-card" key={blog.id}>
                  {/* IMAGE */}

                  <Link
                    to={`/blogs/${blog.slug}`}
                    className="public-blog-image-link"
                  >
                    {blog.image ? (
                      <img
                        src={blog.image}
                        alt={blog.title}
                        className="public-blog-image"
                      />
                    ) : (
                      <div className="public-blog-no-image">
                        <FaBlog />
                      </div>
                    )}

                    <span className="public-blog-category">
                      {blog.category || "Sports"}
                    </span>
                  </Link>

                  {/* CONTENT */}

                  <div className="public-blog-content">
                    <div className="public-blog-meta">
                      <span>
                        <FaUser />

                        {blog.author || "Quality Sports Surface"}
                      </span>

                      <span>
                        <FaCalendarAlt />

                        {formatBlogDate(blog.date || blog.createdAt)}
                      </span>
                    </div>

                    <h2>
                      <Link to={`/blogs/${blog.slug}`}>
                        {blog.title || "Untitled Blog"}
                      </Link>
                    </h2>

                    <p>{blog.excerpt || "Read this article to learn more."}</p>

                    <Link
                      to={`/blogs/${blog.slug}`}
                      className="public-blog-read-more"
                    >
                      Read Article
                      <FaArrowRight />
                    </Link>
                  </div>
                </article>
              ))}
            </div>
          )}
        </div>
      </section>
    </main>
  );
};

export default Blogs;
